/* eslint-disable no-nested-ternary */
import React from "react";
import ct from "class-types.macro";
import { CategoryDetail } from "~/common/Store/models/Category";
const LeafHeader = (detail: CategoryDetail) => {
  return <div className={`page-header-container ${ct("flex", "items-center")}`} data-sentry-component="LeafHeader" data-sentry-source-file="LeafHeader.tsx">
      <div className={ct("flex-1")}>
        <h1 className="page-header">{detail.name}</h1>
        <h2 className="page-header-2">{detail.subtitle}</h2>
      </div>
    </div>;
};
export default LeafHeader;